import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import DropdownVoucherDynamicInput from "../../../../components/Dropdown/DropdownVoucherDynamicInput";
import {
  currencyFormate,
  removeCurrencyComma,
} from "../../../../components/Date_Formate_Utilitiy/Index";

export const PaymentAllocation = ({
  data,
  setData,
  handleChange,
  handleFocus,
  handleBlur,
  inputRefs,
  narr_ref,
  itemLedgerData,
  handleDropdownDynamicClick,
  handleKeyDown,
  isView, // Added isView
  loading,
}) => {
  const modal_state = useSelector((state) => state.common.modal_state);

  // Memoize the input handlers
  const getInputHandlers = useCallback(
    (id, field) => ({
      onChange: (e) => handleChange(e, id, field, e.target.value),
      onKeyUp: (e) => handleChange(e, id, field, e.target.value),
      onFocus: (e) => handleFocus(e, id, field, e.target.value),
      onBlur: (e) => handleBlur(e, id, field, e.target.value),
      onKeyDown: (e) => handleKeyDown(e, id, field),
    }),
    [handleChange, handleFocus, handleBlur, handleKeyDown],
  );

  return (
    <div
      className="row m-0 p-0"
      style={{ height: "12vh", overflowY: "scroll" }}
    >
      <div className="col-12 p-0">
        <div className="row m-0">
          {data?.payment_allocation?.map((item, index) => {
            const paymentLedgerAccountInputHandlers = getInputHandlers(
              item?.id,
              "payment_ledger_account",
            );
            const paymentLedgerAmountInputHandlers = getInputHandlers(
              item?.id,
              "payment_ledger_amount",
            );
            return (
              <div
                key={item?.id || `payment-allocation-row-${index}`}
                className={`col-12 p-0`}
                style={{ height: 19.5, backgroundColor: "transparent" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: 19.5,
                  }}
                >
                  {/* Left spacer */}
                  <div style={{ width: "4%", flexShrink: 0 }}></div>

                  {/* Ledger name - fills remaining space */}
                  <div
                    style={{ flex: 1, minWidth: 0, position: "relative" }}
                    className="container_of_voucher_dynamic_input"
                  >
                    <input
                      type="text"
                      name={`payment_ledger_account${index}`}
                      ref={(el) => {
                        if (!inputRefs.current[item?.id]) {
                          inputRefs.current[item?.id] = {};
                        }
                        inputRefs.current[item?.id].payment_ledger_account = el;
                      }}
                      className="voucher_entry_account_input"
                      value={item?.ledger_name || ""}
                      disabled={isView}
                      {...paymentLedgerAccountInputHandlers}
                    />
                    {modal_state[`payment_ledger_account${item?.id}`] && (
                      <DropdownVoucherDynamicInput
                        title={"List of Ledger Account"}
                        state={modal_state[`payment_ledger_account${item?.id}`]}
                        data={data}
                        setData={setData}
                        input_value={item?.ledger_name}
                        input_key={"payment_ledger_account"}
                        input_id={"payment_ledger_account_id"}
                        input_blc={""}
                        rawData={itemLedgerData}
                        index={index}
                        ref={
                          inputRefs.current[item?.id]?.payment_ledger_account
                        }
                        refs={inputRefs}
                        narr_ref={narr_ref}
                        isDynamic={true}
                        handleDropdownClick={(field, value, index) =>
                          handleDropdownDynamicClick(
                            field,
                            value,
                            index,
                            "payment_allocation",
                          )
                        }
                        loading={loading}
                      />
                    )}
                  </div>

                  {/* Right spacer */}
                  <div style={{ width: "4%", flexShrink: 0 }}></div>

                  {/* Amount input - fixed width, right-aligned */}
                  {data?.payment_allocation[index]
                    ?.payment_ledger_account_id !== "" ? (
                    <div
                      style={{ width: 120, flexShrink: 0 }}
                      className="container_of_voucher_dynamic_input"
                    >
                      <input
                        type="text"
                        style={{
                          textAlign: "right",
                          paddingRight: 5,
                          width: "100%",
                          fontSize: 13,
                        }}
                        name={`payment_ledger_amount${index}`}
                        ref={(el) => {
                          if (!inputRefs.current[item?.id]) {
                            inputRefs.current[item?.id] = {};
                          }
                          inputRefs.current[item?.id].payment_ledger_amount =
                            el;
                        }}
                        className="voucher_entry_account_input"
                        value={item?.payment_ledger_amount || ""}
                        disabled={isView}
                        {...paymentLedgerAmountInputHandlers}
                      />
                    </div>
                  ) : (
                    <div style={{ width: 120, flexShrink: 0 }}></div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
